var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewBurgerOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#00A3A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16C12.5 15.4477 12.9477 15 13.5 15L27 15C27.5523 15 28 15.4477 28 16C28 16.5523 27.5523 17 27 17H13.5C12.9477 17 12.5 16.5523 12.5 16Z",
    fill: "#00A3A4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBurgerOpen);
export default __webpack_public_path__ + "static/media/NewBurgerOpen.073f89d8bbe7fd7f45cbb6dedcb31539.svg";
export { ForwardRef as ReactComponent };